import request from '@/utils/http'

/**
 * 获取询价列表
 * @param {Object} params 查询参数
 */
export function getInquiryList(params) {
  return request({
    url: '/api/inquiry/list',
    method: 'get',
    params
  })
}

/**
 * 获取询价详情
 * @param {Object} data 包含id的参数对象
 */
export function getInquiryDetail(data) {
  return request({
    url: '/api/inquiry/detail',
    method: 'post',
    data
  })
}

/**
 * 撤销询价
 * @param {Object} data 包含id的参数对象
 */
export function cancelInquiry(data) {
  return request({
    url: '/api/inquiry/cancel',
    method: 'post',
    data
  })
}

/**
 * 重新发布询价
 * @param {Number} id 询价ID
 */
export function republishInquiry(id) {
  return request({
    url: `/api/inquiry/republish/${id}`,
    method: 'post'
  })
}

/**
 * 获取询价状态统计
 */
export function getInquiryStatusCount() {
  return request({
    url: '/api/inquiry/status_count',
    method: 'get'
  })
}

/**
 * 提交询价单
 * @param {Object} data 询价数据
 */
export function submitInquiry(data) {
  return request({
    url: '/api/inquiry/submit',
    method: 'post',
    data
  })
}

/**
 * 更新询价单
 * @param {Object} data 询价数据
 */
export function updateInquiry(data) {
  return request({
    url: '/api/inquiry/update',
    method: 'post',
    data
  })
}